<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="list"/>&nbsp;Registrar entrada de bitácora
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
        <sys-form :inputs="entry_details"/>
        <!--end: Details -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: $route.params.type, params: { id: $route.params.id } })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import entryService from '@/services/entries'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'EntryCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      entry_details: {
        title: {
          name: 'Título',
          hint: 'Título',
          value: '',
          type: 'text',
          validate: 'required',
          size: 12
        },
        content: {
          name: 'Contenido',
          hint: 'Contenido',
          value: '',
          type: 'textarea',
          validate: 'required',
          size: 12
        }
      }
    }
  },

  methods: {
    saveForm () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const creatorId = this.$route.params.id
          const username = this.$store.getters.getUsername
          this.entry_details['prospect_id'] = {
            name: 'prospect_id',
            value: creatorId,
            type: 'hidden',
            hide: true
          }
          this.entry_details['author'] = {
            name: 'author',
            value: username,
            type: 'hidden',
            hide: true
          }

          let entryInfo = { ...this.entry_details }

          let body = this.processForm(entryInfo)
          let service = entryService.post(this.$route.params.type, body)

          this.sendForm(service).then(res => {
            this.$router.push({
              name: this.$route.params.type,
              params: { id: this.$route.params.id }
            })
          }).catch(err => {
            console.log(JSON.stringify(err))
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/entries/EntryCreate.vue